import { network } from 'services/network';

export const forgotPassword = (params) => {
    return network.post(`admin/bo/forgotPassword`, params).then(() => {
        return true;
    });
};
